<template>
  <div class="product-page-wrapper">
    <header class="header">
      <img src="../assets/tatusq.png" width="50" />
      <span>Tatu na Grota</span>
    </header>
    
    <section class="hero-section">
      <div class="hero-content">
        <h1>Os melhores ovos caipiras direto da roça 🐓</h1>
        <p>
          Criadas soltas, com alimentação natural e muito verde – nossas galinhas
          produzem ovos de qualidade, com sabor e cor de verdade.
        </p>
        <button class="hero-button" @click="scrollToProducts">
          Faça seu pedido
        </button>
      </div>
    </section>
    
    <section class="feature-grid-wrapper">
      <div class="feature-grid">
        <div
          v-for="card in featureCards"
          :key="card.id"
          :class="['feature-card', { 'is-title-card': card.isTitle }]"
        >
          <span class="material-symbols-outlined">{{ card.icon }}</span>
          <div class="card-text">
            <strong>{{ card.title }}</strong>
            <span>{{ card.text }}</span>
          </div>
        </div>
      </div>
    </section>
    
    <AvaliacoesCarousel />
    
    <main v-if="carregandoPagina" class="loading-overlay">
      Carregando produtos...
    </main>
    
    <main
      v-else-if="produtos.length > 0"
      class="product-list-section"
      id="product-list"
    >
      <h2>Nossos Produtos</h2>
      <div class="product-grid">
        <div v-for="produto in produtos" :key="produto.id" class="product-card">
          
          <div class="product-carousel">
            <div class="promo-ribbon" v-if="false">PROMOÇÃO</div>
            <button @click="mostrarDescricao(produto)" class="info-button-overlay" aria-label="Ver descrição">
              <span class="material-icons-outlined">info</span>
            </button>
            <img
              :src="getProdutoImage(produto)"
              :key="getProdutoImage(produto)"
              alt="Imagem do Produto"
              class="carousel-image"
            />
            <div class="carousel-nav" v-if="produto.images.length > 1">
              <button @click="prevImage(produto)" aria-label="Imagem Anterior">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" class="carousel-nav-svg">
                  <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z" />
                </svg>
              </button>
              <button @click="nextImage(produto)" aria-label="Próxima Imagem">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" class="carousel-nav-svg">
                  <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
                </svg>
              </button>
            </div>
          </div>
          
          <div class="product-info">
            <div class="product-title-wrapper">
              <h1>{{ produto.nome }}</h1>
            </div>
            
            <span class="product-unidade">{{ produto.unidade }}</span>
            <p class="product-price">{{ produto.preco | formatCurrency }}</p>
            
            <div class="qtd-and-buy">
              <div class="quantity-selector">
                <label :for="'quantity-' + produto.id">Qtd:</label>
                <button class="icon-button" @click="decrementQuantity(produto)" :disabled="produto.quantity === 1">
                  <span class="material-icons-outlined">remove</span>
                </button>
                <span class="quantity-display">{{ produto.quantity }}</span>
                <button class="icon-button" @click="incrementQuantity(produto)">
                  <span class="material-icons-outlined">add</span>
                </button>
              </div>
              <button
                class="buy-button"
                @click="irParaCheckout(produto)"
                :disabled="carregando"
              >
                Comprar
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
    
    <div v-else class="loading-overlay">Nenhum produto encontrado.</div>
    
    <section v-if="produtoSelecionado" id="checkout-section" class="checkout-section">
      <div class="checkout-container">
        
        <div class="checkout-header">
          <h2>Finalizar Pedido 🚚</h2>
          <button class="btn-cancelar" @click="cancelarCompra">
            Cancelar / Trocar Produto
          </button>
        </div>
        
        <div class="checkout-body">
          <div class="order-summary">
            <h3>Resumo</h3>
            <div class="summary-item">
              <span class="item-name">{{ produtoSelecionado.nome }}</span>
              <span class="item-qtd">x {{ produtoSelecionado.quantity }}</span>
            </div>
            <div class="summary-total">
              Total: {{ (produtoSelecionado.preco * produtoSelecionado.quantity) | formatCurrency }}
            </div>
            <div class="delivery-warning">
              <span class="material-icons-outlined">event_available</span>
              <p><strong>Atenção:</strong> As entregas são realizadas apenas às <strong>Terças e Quintas</strong>!</p>
            </div>
          </div>
          
          <form @submit.prevent="finalizarCompra" class="checkout-form">
            <h3>Endereço de Entrega</h3>
            
            <div class="form-group">
              <label>Seu Nome Completo</label>
              <input v-model="formCliente.nome" type="text"  placeholder="Ex: João Silva" class="input-tatu" autocomplete="name">
            </div>
            
            <div class="form-group">
              <label>WhatsApp / Telefone</label>
              <input
                v-model="formCliente.telefone"
                type="tel"
                
                placeholder="(99) 99999-9999"
                class="input-tatu"
                @input="formatarTelefone" maxlength="15" >
            </div>
            
            <div class="form-group">
              <label>Cidade</label>
              <div class="city-selector">
                <button
                  type="button"
                  @click="formCliente.cidadeSelecionada = 'Tucumã'"
                  :class="['city-btn', { 'active': formCliente.cidadeSelecionada === 'Tucumã' }]"
                >
                  Tucumã
                </button>
                <button
                  type="button"
                  @click="formCliente.cidadeSelecionada = 'Ourilândia'"
                  :class="['city-btn', { 'active': formCliente.cidadeSelecionada === 'Ourilândia' }]"
                >
                  Ourilândia
                </button>
              </div>
            </div>
            <div class="form-group">
              <label>Rua / Avenida</label>
              <input v-model="formCliente.rua" type="text"  class="input-tatu">
            </div>
            
            <div class="form-row">
              <div class="form-group" style="flex: 1; min-width: 140px;">
                <label>Número</label>
                <input
                  ref="inputNumero"
                  v-model="formCliente.numero"
                  type="text"
                  inputmode="numeric"
                  class="input-tatu"
                  placeholder="123"
                  @input="formatarNumero"
                  maxlength="10"
                  :disabled="formCliente.semNumero"
                >
                
                <div
                  class="sem-numero-toggle"
                  @click="toggleSemNumero"
                  :class="{ 'active': formCliente.semNumero }"
                >
                    <span class="material-icons-outlined icon-check">
                      {{ formCliente.semNumero ? 'check_box' : 'check_box_outline_blank' }}
                    </span>
                  <span>Sem número</span>
                </div>
              </div>
              
              <div class="form-group" style="flex: 2; min-width: 140px;">
                <label>Bairro</label>
                <input v-model="formCliente.bairro" type="text" class="input-tatu">
              </div>
            </div>
            
            <div class="form-group">
              <label>Complemento (Opcional)</label>
              <input v-model="formCliente.complemento" type="text" placeholder="Ex: Casa fundos" class="input-tatu">
            </div>
            
            <button type="submit" class="btn-finalizar" :disabled="carregando">
              {{ carregando ? 'Gerando Pagamento...' : 'Ir para Pagamento' }}
            </button>
          </form>
        </div>
      </div>
    </section>
    
    <div
      v-if="exibirModalDetalhesProduto"
      class="modal-overlay"
      @click.self="fecharDescricao"
    >
      <div class="modal-content">
        <button @click="fecharDescricao" class="modal-close-btn" aria-label="Fechar">
          <span class="material-icons-outlined">close</span>
        </button>
        <h2>{{ produtoDetalhe.nome }}</h2>
        <p>{{ produtoDetalhe.descricao }}</p>
      </div>
    </div>
    
    <footer class="footer">
      <div class="footer-content">
        <p><strong>Chácara Tatu na Grota, Tucumã - PA</strong></p>
        <p>
          Contato: <a href="tel:94992435784">(94) 99243-5784</a> |
          <a href="mailto:contato@tatunagrota.com.br">contato@tatunagrota.com.br</a>
        </p>
      </div>
      
      <div class="developer-credits">
        <hr class="footer-divider">
        <p>
          Desenvolvido por
          <a href="https://github.com/lurkasf" target="_blank" rel="noopener noreferrer">
            Lucas Ferrari <span class="dev-icon">💻</span>
          </a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import api from '@/services/api';
import {AlertBus} from "@/plugins/AlertBus";
import AvaliacoesCarousel from "@/components/AvaliacoesCarousel.vue";

export default {
  name: "Comprar",
  components:{ AvaliacoesCarousel },
  data() {
    return {
      featureCards: [
        {
          id: "title",
          isTitle: false,
          icon: "nest_eco_leaf",
          title: "Produção Natural",
          text: "Alimentação 100% vegetal à base de milho, verduras e grãos selecionados, sem aditivos químicos.",
        },
        {
          id: "no-cage",
          isTitle: false,
          icon: "heart_smile",
          title: "Bem-estar das Aves",
          text: "Galinhas criadas livres, com espaço para ciscar, tomar sol e viver naturalmente.",
        },
        {
          id: "pasture",
          isTitle: false,
          icon: "egg",
          title: "Qualidade Garantida",
          text: "Ovos sempre frescos, selecionados e entregues com todo o cuidado direto da roça até você.",
        },
        {
          id: "no-antibiotics",
          isTitle: false,
          icon: "pill",
          title: "Livres de Antibióticos",
          text: "Nossas galinhas são criadas de forma natural, sem o uso de antibióticos ou aditivos químicos o resultado é um ovo mais saudável para você e sua família.",
        },
      ],
      produtos: [],
      carregando: false,
      carregandoPagina: true,
      
      // Controle da Descrição
      exibirModalDetalhesProduto: false,
      produtoDetalhe: null,
      
      // Controle do Checkout
      produtoSelecionado: null,
      formCliente: {
        nome: '',
        telefone: '',
        rua: '',
        numero: '',
        complemento: '',
        semNumero: false,
        bairro: '',
        cidadeSelecionada: '',
      },
      
      numeroTemp: null
    };
  },
  methods: {
    toggleSemNumero() {
      this.formCliente.semNumero = !this.formCliente.semNumero;
      
      if (this.formCliente.semNumero) {
        this.numeroTemp = this.formCliente.numero || '';
        this.formCliente.numero = 'S/N';
      } else {
        this.formCliente.numero = this.numeroTemp || '';
      }
    },
    
    // --- Ações de Produto ---
    incrementQuantity(produto) {
      produto.quantity++;
    },
    decrementQuantity(produto) {
      if (produto.quantity > 1) {
        produto.quantity--;
      }
    },
    nextImage(produto) {
      if (produto.images.length > 1) {
        produto.currentImageIndex =
          (produto.currentImageIndex + 1) % produto.images.length;
      }
    },
    prevImage(produto) {
      if (produto.images.length > 1) {
        produto.currentImageIndex =
          (produto.currentImageIndex - 1 + produto.images.length) %
          produto.images.length;
      }
    },
    getProdutoImage(produto) {
      if (!produto.images || produto.images.length === 0) {
        return "https://placehold.co/600x600/f0f0f0/ccc?text=Sem+Imagem";
      }
      return produto.images[produto.currentImageIndex];
    },
    mostrarDescricao(produto) {
      this.produtoDetalhe = produto;
      this.exibirModalDetalhesProduto = true;
    },
    fecharDescricao() {
      this.exibirModalDetalhesProduto = false;
      this.produtoDetalhe = null;
    },
    
    // --- Scroll ---
    async scrollToProducts() {
      let el = document.getElementById("product-list");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      } else {
        await this.carregarProdutos();
        this.$nextTick(() => {
          el = document.getElementById("product-list");
          if (el) {
            el.scrollIntoView({ behavior: "smooth" });
          } else {
            AlertBus.$emit('show-alert', {
              message: 'Nenhum produto disponível no momento.',
              type: 'erro'
            });
          }
        });
      }
    },
    
    // --- API Inicial ---
    async carregarProdutos() {
      this.carregandoPagina = true;
      try {
        const res = await api.get(`/api/produtos`);
        this.produtos = res.data.map((produto) => ({
          ...produto,
          quantity: 1,
          currentImageIndex: 0,
        }));
      } catch (err) {
        console.error("Erro ao carregar produtos:", err);
        this.produtos = [];
      } finally {
        this.carregandoPagina = false;
      }
    },
    
    formatarTelefone() {
      // 1. Limpa tudo que não for dígito
      let digitos = this.formCliente.telefone.replace(/\D/g, '');
      
      // 2. Limita a 11 dígitos (DDD + 9 + 8 dígitos)
      digitos = digitos.substring(0, 11);
      
      // 3. Aplica a máscara (99) 99999-9999
      let formatado = '';
      if (digitos.length > 0) {
        formatado = `(${digitos.substring(0, 2)}`;
      }
      if (digitos.length > 2) {
        formatado += `) ${digitos.substring(2, 7)}`;
      }
      if (digitos.length > 7) {
        formatado += `-${digitos.substring(7, 11)}`;
      }
      
      // 4. Atualiza o v-model
      this.formCliente.telefone = formatado;
    },
    
    formatarNumero() {
      // Se for S/N, não faz nada. Se não, remove letras.
      if (this.formCliente.semNumero) return;
      this.formCliente.numero = this.formCliente.numero.replace(/\D/g, '');
    },
    
    // --- Fluxo de Checkout ---
    irParaCheckout(produto) {
      this.produtoSelecionado = produto;
      this.$nextTick(() => {
        const checkoutSection = document.getElementById("checkout-section");
        if (checkoutSection) {
          checkoutSection.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    
    cancelarCompra() {
      this.produtoSelecionado = null;
      this.scrollToProducts();
    },
    
    async finalizarCompra() {
      // --- Validações Avançadas ---
      
      // Regex para checar se HÁ números
      const temNumeros = /\d/;
      // Regex para checar se é *APENAS* números (após trim)
      const apenasNumeros = /^\d+$/;
      
      // --- Checagens ---
      
      // Validação de Nome
      if (!this.formCliente.nome) {
        AlertBus.$emit('show-alert', { message: 'Por favor, digite seu nome.', type: 'alerta' });
        return;
      }
      if (temNumeros.test(this.formCliente.nome)) {
        AlertBus.$emit('show-alert', { message: "O Nome não pode conter números.", type: 'alerta' });
        return;
      }
      if (this.formCliente.nome.trim().indexOf(' ') === -1) {
        AlertBus.$emit('show-alert', { message: 'Por favor, digite seu nome completo.', type: 'alerta' });
        return;
      }
      
      // Validação do Telefone
      const digitosTelefone = this.formCliente.telefone.replace(/\D/g, '');
      if (digitosTelefone.length < 1) {
        AlertBus.$emit('show-alert', { message: 'Por favor, informe o WhatsApp/Telefone.', type: 'alerta' });
        return;
      }
      if (digitosTelefone.length < 10) {
        AlertBus.$emit('show-alert', { message: 'O número de WhatsApp/Telefone parece incompleto. Por favor, inclua o DDD.', type: 'alerta' });
        return;
      }
      
      if (!this.formCliente.cidadeSelecionada) {
        AlertBus.$emit('show-alert', { message: 'Por favor, selecione sua cidade.', type: 'alerta' });
        return;
      }
      
      // Validação de Rua
      if (!this.formCliente.rua) {
        AlertBus.$emit('show-alert', { message: "Por informe a Rua.", type: 'alerta' });
        return;
      }
      if (apenasNumeros.test(this.formCliente.rua.trim())) {
        AlertBus.$emit('show-alert', { message: "A Rua não pode conter apenas números.", type: 'alerta' });
        return;
      }
      
      // Validação de Número (Graças ao formatarNumero, só precisamos checar se está vazio)
      if (!this.formCliente.numero) {
        AlertBus.$emit('show-alert', { message: "Por favor, informe Número do endereço", type: 'alerta' });
        return;
      }
      
      // Validação de Bairro
      if (!this.formCliente.bairro) {
        AlertBus.$emit('show-alert', { message: "Por favor, informe o Bairro.", type: 'alerta' });
        return;
      }
      if (apenasNumeros.test(this.formCliente.bairro.trim())) {
        AlertBus.$emit('show-alert', { message: "O Bairro não pode conter apenas números.", type: 'alerta' });
        return;
      }
      // --- Fim das Validações ---
      
      this.carregando = true;
      const produto = this.produtoSelecionado;
      
      const payload = {
        productId: produto.id,
        quantity: produto.quantity,
        cliente: {
          nome: this.formCliente.nome.trim(),
          telefone: digitosTelefone,
          endereco: {
            rua: this.formCliente.rua.trim(),
            numero: this.formCliente.numero,
            complemento: this.formCliente.complemento.trim(),
            bairro: this.formCliente.bairro.trim(),
            cidade: this.formCliente.cidadeSelecionada,
          }
        }
      };
      
      try {
        const res = await api.post(`/api/create-payment`, payload);
        window.location.href = res.data.init_point;
      } catch (err) {
        const errorText = err.response?.data?.error || err.message;
        AlertBus.$emit('show-alert', {
          message: `Erro ao iniciar pagamento: ${errorText}`,
          type: 'erro',
          duration: 6000
        });
        this.carregando = false;
      }
    },
  },
  filters: {
    formatCurrency(value) {
      const numValue = Number(value);
      if (isNaN(numValue)) {
        return "R$ 0,00";
      }
      return "R$ " + numValue.toFixed(2).replace(".", ",");
    },
  },
  mounted() {
    this.carregarProdutos();
  },
};
</script>

<style scoped lang="css">
/* Reset básico */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.loading-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 70vh;
  font-size: 1.5rem;
  color: #888;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
  Arial, sans-serif;
}

.product-page-wrapper {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  line-height: 1.6;
  background-color: var(--bg-main);
  color: var(--text-main);
  color-scheme: dark;
  overflow-x: hidden;/*TODO isso é uma boa ideia???*/
}

/* Header */
.header {
  padding: 5px;
  text-align: center;
  background-color: var(--bg-header);
  border-bottom: 1px solid var(--border-light);
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--color-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

/* Hero */
.hero-section {
  background-color: var(--bg-header);
  color: var(--text-hero);
  padding: 60px 20px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.hero-content {
  max-width: 700px;
}
.hero-content h1 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 15px;
}
.hero-content p {
  font-size: 1.1rem;
  margin-bottom: 25px;
  color: var(--text-main);
}
.hero-button {
  background-color: var(--color-hero-button-bg);
  color: var(--color-hero-button-text);
  font-weight: bold;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1.1rem;
  transition: background-color 0.2s;
}
.hero-button:hover {
  background-color: var(--color-hero-button-hover-bg);
}

/* Feature Cards */
.feature-grid-wrapper {
  padding: 30px 20px;
  background-color: var(--bg-main);
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}
.feature-grid {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
}
.feature-card {
  background-color: var(--card-feature-bg);
  border: 2px solid var(--card-feature-border);
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  color: var(--card-feature-text);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 180px;
}
.card-text strong {
  display: block;
  margin-bottom: 5px;
  font-size: 1.1rem;
}

/* Produto Section */
.product-list-section {
  padding: 40px 20px;
  background-color: var(--bg-main);
  max-width: 100%;
  margin: 0 auto;
}
.product-list-section h2 {
  font-size: 2rem;
  text-align: center;
  margin-bottom: 30px;
  color: var(--text-hero);
}
.product-grid {
  display: grid;
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, 300px);
}
.product-card {
  display: flex;
  flex-direction: column;
  background-color: var(--bg-card);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  color: var(--text-main);
  text-align: center;
  width: 100%;
}

/* Carrossel */
.product-carousel {
  position: relative;
  overflow: hidden;
  border-radius: 8px 8px 0 0;
  background-color: var(--bg-image-placeholder);
  width: 100%;
  padding-top: 100%;
  height: 0;
  margin-bottom: 15px;
}
.carousel-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.carousel-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 5px;
  z-index: 10;
}
.carousel-nav button {
  background-color: var(--bg-carousel-nav);
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.carousel-nav-svg {
  fill: var(--color-carousel-nav-icon);
  width: 24px;
  height: 24px;
}

/* Info do Produto */
.product-info {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0 20px 20px;
}
.product-title-wrapper {
  width: 100%;
  margin-bottom: 5px;
  text-align: center;
}
.product-title-wrapper h1 {
  margin: 0;
  width: 100%;
  font-size: 1.4rem;
  line-height: 1.2;
  padding: 0 5px;
}
.info-button-overlay {
  position: absolute;
  bottom: 5px;    /* Margem do topo da imagem */
  right: 10px;  /* Margem da direita da imagem */
  z-index: 20;  /* Garante que fique acima da imagem */
  
  /* Visual de botão flutuante discreto */
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.3);
  
  //width: 32px;
  //height: 32px;
  border-radius: 50%;
  
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.info-button-overlay:hover {
  background-color: rgba(0, 0, 0, 0.7);
  transform: scale(1.1);
}

.info-button-overlay .material-icons-outlined {
  font-size: 20px;
}
.product-price {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--color-accent);
  margin-top: 5px;
}
.product-unidade {
  width: fit-content;
  padding: 2px 8px;
  background-color: var(--bg-tag);
  border-radius: 4px;
  color: var(--color-tag-text);
  font-size: 0.8em;
  margin: 0 auto 10px;
}
.quantity-selector {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  margin-top: auto;
  padding-top: 15px;
}
.quantity-selector label {
  font-weight: 600;
  margin-right: 10px;
  color: var(--text-main);
}
.icon-button {
  width: 34px;
  height: 34px;
  border: 1px solid var(--color-icon-button-border);
  background-color: var(--bg-icon-button);
  color: var(--color-icon-button-text);
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.quantity-display {
  width: 40px;
  text-align: center;
  font-size: 1.1rem;
  font-weight: bold;
  color: var(--text-main);
}
.buy-button {
  width: 100%;
  padding: 14px;
  font-size: 1.1rem;
  font-weight: 700;
  color: #fff;
  background-color: var(--color-button-buy);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-transform: uppercase;
  transition: background-color 0.2s;
}
.buy-button:hover {
  background-color: var(--color-button-buy-hover-bg);
}
.buy-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ========================================
   SEÇÃO DE CHECKOUT (ESTILOS)
  ========================================
*/
.checkout-section {
  padding: 40px 20px;
  background-color: var(--bg-card); /* Destaque de fundo */
  border-top: 1px solid var(--border-light);
  border-bottom: 1px solid var(--border-light);
  animation: slideInUp 0.5s ease;
}

.checkout-container {
  max-width: 900px;
  margin: 0 auto;
}

.checkout-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 15px;
}

.checkout-header h2 {
  color: var(--color-accent);
  font-size: 1.8rem;
  margin: 0;
}

.btn-cancelar {
  background: transparent;
  border: 1px solid var(--border-light);
  color: var(--text-secondary);
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}
.btn-cancelar:hover {
  background-color: var(--bg-main);
  color: var(--text-main);
}

.checkout-body {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 40px;
  align-items: start;
}

/* Resumo do Pedido */
.order-summary {
  background-color: var(--bg-main);
  padding: 20px;
  border-radius: 8px;
  border: 1px solid var(--border-light);
}
.order-summary h3 {
  margin-bottom: 15px;
  font-size: 1.2rem;
  color: var(--text-hero);
  border-bottom: 1px solid var(--border-light);
  padding-bottom: 10px;
}
.summary-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  font-size: 1.1rem;
}
.item-name { font-weight: bold; }
.item-qtd { color: var(--text-secondary); }

.summary-total {
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid var(--border-light);
  font-size: 1.4rem;
  font-weight: 800;
  color: var(--color-accent);
  text-align: right;
}

/* Aviso de Entrega */
.delivery-warning {
  margin-top: 20px;
  padding: 12px 15px;
  background-color: rgba(125, 125, 125, 0.1); /* Fundo sutil transparente */
  border: 1px solid var(--color-accent); /* Borda na cor do tema */
  border-left-width: 5px; /* Destaque lateral */
  border-radius: 4px;
  color: var(--text-main);
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.95rem;
  line-height: 1.4;
  text-align: left;
}

.delivery-warning .material-icons-outlined {
  color: var(--color-accent);
  font-size: 24px;
}

.delivery-warning strong {
  color: var(--color-accent); /* Destaque no texto */
}

/* Formulário */
.checkout-form {
  background-color: var(--bg-main);
  padding: 25px;
  border-radius: 8px;
  border: 1px solid var(--border-light);
  box-shadow: 0 4px 6px rgba(0,0,0,0.05);
}
.checkout-form h3 {
  margin-bottom: 20px;
  font-size: 1.2rem;
  color: var(--text-hero);
}

.form-group {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  text-align: left;
}
.form-row {
  display: flex;
  gap: 0 15px;
  flex-wrap: wrap;
}
.form-group label {
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 5px;
  color: var(--text-secondary);
}
.input-tatu {
  padding: 12px;
  border: 1px solid var(--border-light);
  border-radius: 6px;
  background-color: var(--bg-card);
  color: var(--text-main);
  font-size: 1rem;
  width: 100%;
}
.input-tatu:focus {
  outline: none;
  border-color: var(--color-accent);
  box-shadow: 0 0 0 2px rgba(var(--color-accent), 0.2);
}

.btn-finalizar {
  width: 100%;
  padding: 16px;
  font-size: 1.2rem;
  font-weight: bold;
  color: #fff;
  background-color: var(--color-button-buy);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 10px;
  transition: transform 0.1s;
}
.btn-finalizar:hover {
  background-color: var(--color-button-buy-hover-bg);
}
.btn-finalizar:active {
  transform: scale(0.98);
}

/* Responsividade da Seção de Checkout */
@media (max-width: 768px) {
  .checkout-body {
    grid-template-columns: 1fr; /* Empilha em mobile */
    gap: 20px;
  }
  .order-summary {
    order: -1; /* Resumo primeiro */
  }
  .checkout-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

/* Modal Descrição (Simples) */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--bg-modal-overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  animation: fadeIn 0.3s ease;
}
.modal-content {
  position: relative;
  background-color: var(--bg-card);
  color: var(--text-main);
  padding: 30px;
  border-radius: 8px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
}
.modal-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  color: var(--text-main);
  cursor: pointer;
}

@keyframes slideInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* ===== INÍCIO ESTILOS ADICIONADOS ===== */
.city-selector {
  display: flex;
  gap: 10px;
  width: 100%;
}

.city-btn {
  flex: 1;
  padding: 12px 10px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  
  /* Aparência Padrão (Não selecionado) */
  background-color: var(--bg-card);
  border: 1px solid var(--border-light);
  color: var(--text-secondary);
  transition: all 0.2s ease;
}

.city-btn.active {
  /* Aparência Selecionado */
  background-color: var(--color-button-buy);
  border-color: var(--color-button-buy);
  color: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.city-btn:hover:not(.active) {
  background-color: var(--bg-main);
  border-color: var(--color-accent);
}
/* ===== FIM ESTILOS ADICIONADOS ===== */


/* Footer */
.footer {
  margin-top: auto;
  padding: 20px 20px;
  background-color: var(--bg-footer);
  color: var(--text-main);
  text-align: center;
  font-size: 0.9rem;
  border-top: 1px solid var(--border-light);
}

.footer a {
  color: var(--color-footer-link, var(--color-accent));
  text-decoration: none;
  font-weight: 600;
  transition: opacity 0.2s;
}

.footer a:hover {
  opacity: 0.8;
  text-decoration: underline;
}

/* Estilos específicos para os créditos do desenvolvedor */
.developer-credits {
  margin-top: 5px;
  font-size: 0.8rem; /* Um pouco menor que o texto da loja */
  opacity: 0.8;      /* Levemente transparente para ser sutil */
}

.footer-divider {
  border: 0;
  border-top: 1px solid var(--border-light);
  margin: 5px auto;
  width: 50px;
  opacity: 0.5;
}

.dev-icon {
  font-size: 1rem;
  margin-left: 4px;
  vertical-align: baseline;
}

.promo-ribbon {
  position: absolute;
  top: 15px;
  left: 15px;
  
  /* 2. Tamanho generoso (pode ser maior que a imagem, o overflow do pai corta) */
  width: 300px;
  
  /* 3. Estilo Visual */
  background-color: #D50000;
  color: white;
  font-weight: 800;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  padding: 5px 0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
  z-index: 20;
  pointer-events: none;
  
  /* 4. Centralização do texto dentro da faixa */
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  
  /* A ordem das transformações é crucial: */
  
  transform:
    /* Passo A: Move o CENTRO da faixa para o ponto 0,0 (o canto da imagem) */
    translateX(-50%) translateY(-50%)
      
      /* Passo B: Gira 45 graus anti-horário em torno desse centro */
    rotate(-45deg)
      
      /* Passo C: Empurra a faixa para baixo no eixo Y LOCAL (que agora é a diagonal) */
      /* Ajuste ESTE valor para controlar a distância do canto (ex: 40px, 60px) */
    translateY(45px);
  
  /* Garante que a rotação ocorra pelo centro */
  transform-origin: center;
}

/* Estilo do botãozinho embaixo do input */
.sem-numero-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  
  /* CORREÇÃO: Aproxima do input de cima */
  margin-top: 5px;
  /* Garante um respiro pequeno embaixo antes da margem do form-group */
  margin-bottom: 5px;
  
  font-size: 0.9rem;
  color: var(--text-secondary);
  cursor: pointer;
  user-select: none;
  transition: color 0.2s;
  white-space: nowrap;
  width: max-content;
}

.sem-numero-toggle:hover {
  color: var(--text-main);
}

.sem-numero-toggle.active {
  color: var(--color-accent);
  font-weight: 600;
}

.sem-numero-toggle .icon-check {
  font-size: 20px; /* Ícone um pouco maior para facilitar o toque */
}
</style>